import React from 'react';
import { useModeration } from './useModeration';
import ModerationQueue from './ModerationQueue';
import RiskProfilePanel from './RiskProfilePanel';
import ReviewModal from './ReviewModal';

export const ContentModerationPanel: React.FC = () => {
  const model = useModeration();
  const { notification, setNotification } = model;

  return (
    <div>
      {notification && (
        <div className="fixed top-4 right-4 z-50 px-4 py-3 rounded-lg text-sm font-semibold shadow-lg flex items-center gap-2"
          style={{
            backgroundColor: notification.type === 'success' ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
            color: notification.type === 'success' ? 'var(--admin-success)' : 'var(--admin-error)',
            border: `1px solid ${notification.type === 'success' ? 'var(--admin-success)' : 'var(--admin-error)'}`,
          }}
        >
          <span className="flex-1">{notification.message}</span>
          <button onClick={() => { navigator.clipboard.writeText(notification.message); }} className="admin-icon-btn text-xs" aria-label="Copy notification text" style={{ padding: 0, minWidth: 44 }}>Copy</button>
          <button onClick={() => setNotification(null)} className="admin-icon-btn" aria-label="Dismiss notification">×</button>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ModerationQueue model={model} />
        </div>
        <div className="lg:col-span-1">
          <RiskProfilePanel model={model} />
        </div>
      </div>

      <ReviewModal model={model} />
    </div>
  );
};
